module.exports = __webpack_public_path__ + "media/images/signatures/serg-f7f4f6e4d1a32a85ce71f773816e1497.png";